import NewPraca from './NewPraca';
export default NewPraca;